import { render, staticRenderFns } from "./gnss-reports.vue?vue&type=template&id=2fa1e0c4&scoped=true"
import script from "./gnss-reports.vue?vue&type=script&lang=js"
export * from "./gnss-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1e0c4",
  null
  
)

export default component.exports